import get from 'lodash-es/get'
import * as React from 'react'

import { IItemCard } from '../interface'

import DownloadIcon from '../../../components/icons/download'
import CollectionButton from '../../buttons/collectionButton'
import FavoriteButton from '../../buttons/favoriteButton/favoriteButton'
import FullscreenButton from '../../buttons/fullscreenButton'
import MutedIcon from '../../icons/muted'
import UnmutedIcon from '../../icons/unmuted'

import * as styles from './lockupPreviewActionPanel.module.css'

interface ILockupPreviewActionPanel extends IItemCard {
  includeMuteUnmute?: boolean
  muted?: boolean
  includeFullscreen?: boolean
  onFullscreen?: () => any
  onMuteVideo?: () => any
  onUnmuteVideo?: () => any
  onDownloadVideoPreview?: () => any
}

const LockupPreviewActionPanel = ({
  item,
  onAddToCollections,
  onAddToFavourites,
  includeMuteUnmute,
  muted,
  onMuteVideo,
  onUnmuteVideo,
  includeFullscreen,
  onFullscreen,
  onDownloadVideoPreview
}: ILockupPreviewActionPanel) => {
  const downloadUrl = get(
    item,
    'previews.icon_with_video_preview.video_preview_download_url'
  )

  return (
    <div className={styles.root}>
      {includeMuteUnmute && (
        <button
          onClick={muted ? onUnmuteVideo : onMuteVideo}
          className={styles.muteButton}
        >
          {muted && <MutedIcon className={styles.muteIcon} />}
          {!muted && <UnmutedIcon className={styles.muteIcon} />}
        </button>
      )}

      <span className={styles.actionButtons}>
        {includeFullscreen && (
          <FullscreenButton
            onClick={onFullscreen}
            className={styles.rightSeparator}
            iconClassName={styles.fullscreenButton}
          />
        )}

        {downloadUrl ? (
          <a
            role="button"
            href={downloadUrl}
            className={styles.rightSeparator}
            onClick={onDownloadVideoPreview}
            title="Download Preview"
            rel="nofollow"
          >
            <DownloadIcon className={styles.downloadButton} />
          </a>
        ) : null}

        <CollectionButton
          href={`/bookmarks/widget?item_id=${item.id}`}
          onClick={onAddToCollections}
          isActive={false}
          className={styles.rightSeparator}
          iconClassName={styles.collectionButton}
        />

        <FavoriteButton
          href={`/favorites?item_id=${item.id}`}
          onClick={onAddToFavourites}
          isActive={item.ui.isInFavourites}
          iconClassName={styles.favoriteButton}
        />
      </span>
    </div>
  )
}

export default LockupPreviewActionPanel
